import React from 'react';
import { Mic, Video, Music2, GraduationCap, Radio, Rocket } from 'lucide-react';
import { Card, CardContent } from './ui/card';

const Services = () => {
  const services = [
    {
      icon: Music2,
      title: 'Áudio',
      items: [
        'Produção musical',
        'Arranjos',
        'Gravação/Edição',
        'Mixagem',
        'Masterização',
      ],
      gradient: 'from-[#ff6b35] to-[#ff8555]',
    },
    {
      icon: Video,
      title: 'Vídeo',
      items: [
        'Vídeo Clipes em estúdio ou externos, dublados ou ao vivo',
        'Gravação de shows ao vivo incluindo estrutura completa de sonorização, luz, gravação de áudio e vídeo e edição.',
      ],
      gradient: 'from-[#48a9a6] to-[#68c9c6]',
    },
    {
      icon: Radio,
      title: 'Jingle',
      items: [
        'Quer fixar de vez sua marca? Fazemos a música certa para isso',
        'Também fazemos trilhas para animações, filmes, vinhetas e etc.',
      ],
      gradient: 'from-[#1e3a5f] to-[#2e5a8f]',
    },
    {
      icon: GraduationCap,
      title: 'Info Produtor',
      items: [
        'Filmamos e editamos cursos online',
        'Temos nosso estúdio com fundo infinito e tratamento acústico, mas também filmamos em salas de aula, auditórios, eventos e muito mais.',
      ],
      gradient: 'from-[#ff6b35] to-[#48a9a6]',
    },
    {
      icon: Mic,
      title: 'Podcast',
      items: [
        'Gravação de Podcast ou Videocast em estúdio com conforto e qualidade profissional.',
      ],
      gradient: 'from-[#48a9a6] to-[#1e3a5f]',
    },
    {
      icon: Rocket,
      title: 'Lançamento de Cursos',
      items: [
        'Além de filmar e editar seu curso, nós também fazemos seu site de vendas, vídeo de vendas, criativos para tráfego pago e criação de campanhas no Google Ads e Meta.',
        'Nós entregamos seu curso pronto para vender de ponta a ponta.',
      ],
      gradient: 'from-[#ff6b35] to-[#ff5520]',
    },
  ];

  return (
    <section id="servicos" className="py-16 bg-white relative overflow-hidden">
      {/* Background decoration */}
      <div className="absolute top-0 left-0 w-72 h-72 bg-[#48a9a6]/5 rounded-full blur-3xl"></div>
      <div className="absolute bottom-0 right-0 w-96 h-96 bg-[#ff6b35]/5 rounded-full blur-3xl"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        {/* Section Header */}
        <div className="text-center mb-12 space-y-4">
          <div className="inline-block">
            <span className="text-[#ff6b35] font-semibold text-sm uppercase tracking-wider bg-[#ff6b35]/10 px-4 py-2 rounded-full">
              Nossos Serviços
            </span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-[#1e3a5f]">
            Crie, grave, conecte!
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Serviços completos de estúdio audiovisual em Brasília: gravação de podcasts, cursos EAD, produção musical e videoclipes
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <Card
              key={index}
              className="group hover:shadow-2xl transition-all duration-500 border-2 border-transparent hover:border-[#ff6b35]/20 overflow-hidden"
            >
              <CardContent className="p-8">
                {/* Icon */}
                <div className={`w-16 h-16 bg-gradient-to-br ${service.gradient} rounded-xl flex items-center justify-center mb-6 group-hover:scale-110 group-hover:rotate-3 transition-all duration-300 shadow-lg`}>
                  <service.icon className="text-white" size={32} />
                </div>

                {/* Title */}
                <h3 className="text-2xl font-bold text-[#1e3a5f] mb-4 group-hover:text-[#ff6b35] transition-colors duration-300">
                  {service.title}
                </h3>

                {/* Items */}
                <div className="space-y-3">
                  {service.items.map((item, itemIndex) => (
                    <div key={itemIndex} className="flex items-start space-x-3">
                      <div className="w-1.5 h-1.5 bg-[#ff6b35] rounded-full mt-2 flex-shrink-0"></div>
                      <p className="text-gray-600 leading-relaxed">{item}</p>
                    </div>
                  ))}
                </div>
              </CardContent>
            </Card>
          ))}
        </div>

        {/* CTA */}
        <div className="text-center mt-12">
          <button
            onClick={() => window.open('https://wa.me/5561985533770', '_blank')}
            className="inline-flex items-center px-8 py-4 bg-gradient-to-r from-[#ff6b35] to-[#ff8555] text-white font-semibold rounded-full shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-300"
          >
            <Mic className="mr-2" size={20} />
            Solicitar Orçamento
          </button>
        </div>
      </div>
    </section>
  );
};

export default Services;